module.exports = {
  NODE_ENV: '"production"',
  API_URL: '"https://api.heltopplagt.no/api"',
  // API_URL: '"http://195.18.155.58:8110/api"',
  // API_URL: '"http://euros02-app:8110/api"',
  VERSION: '"1.6.2"',
};



// WEBPACK FOOTER //
// ./config/prod.env.js